<form name="modifyRechnungForm"
      #modifyRechnungForm="ngForm"
      (ngSubmit)="submitForm(modifyRechnungForm)"
      *transloco="let t">
    <div class="modal-body">
        <h1>{{ t('COMMON.RECHNUNG_AKTION_BEARBEITEN', {nummer: rechnung.rechnungsNummer}) }}</h1>

        <div class="row text-left">
            <div class="col-sm-6">
                <h2>{{ t('FAKTURA.STATUS_AENDERN') }}</h2>

                <select class="form-control"
                        name="status"
                        [(ngModel)]="externalStatus"
                        [tooltip]="t('FAKTURA.STATUS_AUSWAEHLEN')"
                        [attr.aria-label]="t('FAKTURA.STATUS_AUSWAEHLEN')"
                        required>
                    @if (rechnung.externalStatus) {
                        <optgroup [label]="t('FAKTURA.STATUS_AKTUELL')">
                            <option [ngValue]="rechnung.externalStatus">{{ t(rechnung.externalStatus.msgKey) }}</option>
                        </optgroup>
                    }
                    <optgroup [label]="t('FAKTURA.STATUS_OPTIONS')">
                        @for (status of availableStateTransitions; track $index) {
                            <option [ngValue]="status">{{ t(status.msgKey) }}</option>
                        }
                    </optgroup>
                </select>
            </div>

            <div class="col-sm-6">
                <h2>{{ t('FAKTURA.ZAHLUNGSFRIST_AENDERN') }}</h2>

                <dvlib-datepicker-textfield [(ngModel)]="zahlungsFrist"
                                            name="zahlungsFrist"
                                            required
                                            [placeholder]="t('COMMON.ZAHLUNGSFRIST_PLACEHOLDER')"
                                            autofocus>
                </dvlib-datepicker-textfield>
            </div>
        </div>

        <div class="text-left normal-abstand-top">
            <h2>{{ t('FAKTURA.RECHNUNGSGEBUEHREN_BEARBEITEN') }}</h2>
            <h3 class="hidden-xs">{{ t('FAKTURA.GEBUEHREN') }}</h3>

            @if (customPositions.length === 0) {
                <p class="small-abstand-bottom">{{ t('FAKTURA.KEINE_GEBUEHREN') }}</p>
            }

            @for (position of customPositions; track position; let i = $index) {
                <fieldset [ngModelGroup]="'custom-position-' + i">
                    <legend class="visible-xs">
                        {{ t('FAKTURA.GEBUEHR_LEGEND', {index: i + 1}) }}
                    </legend>

                    <div data-testid="custom-position" class="row">
                        <div class="col-xs-6 col-sm-4">
                            <input class="form-control"
                                   type="text"
                                   name="bezeichnung"
                                   [(ngModel)]="position.text"
                                   [disabled]="position.disabled"
                                   [attr.aria-label]="t('COMMON.BEZEICHNUNG')"
                                   [placeholder]="t('COMMON.BEZEICHNUNG')"
                                   [tooltip]="t('COMMON.BEZEICHNUNG')"
                                   required>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <input class="form-control"
                                   type="number"
                                   name="betrag"
                                   [(ngModel)]="position.betrag"
                                   [disabled]="position.disabled"
                                   [attr.aria-label]="t('COMMON.BETRAG_CHF')"
                                   [placeholder]="t('COMMON.BETRAG_CHF')"
                                   [tooltip]="t('COMMON.BETRAG_CHF')"
                                   min="0"
                                   required>
                        </div>
                        @if (editable) {
                            <div class="col-sm-4">
                                <button type="button"
                                        class="btn btn-link form-linker normal-abstand-bottom"
                                        (click)="removeGebuehr(position)">
                                    {{ t('FAKTURA.GEBUEHR_LOSCHEN') }}
                                </button>
                            </div>
                        }
                    </div>
                </fieldset>
            }

            @if (editable) {
                <button type="button"
                        class="btn btn-link"
                        (click)="addGebuehr()">
                    {{ t('FAKTURA.GEBUEHR_HINZUFUEGEN') }}
                </button>
            }
        </div>
    </div>
    <div class="modal-footer text-left big-abstand-top">
        <div class="text-left">
            <dvlib-button-list>
                @if (editable) {
                    <dvlib-loading-button type="submit" [isLoading]="isLoading()">
                        {{ t('COMMON.SPEICHERN') }}
                    </dvlib-loading-button>
                }
                <button type="button"
                        class="btn btn-link"
                        [class.invisible]="isLoading()"
                        (click)="hide()">
                    {{ t('COMMON.ABBRECHEN') }}
                </button>
            </dvlib-button-list>
        </div>
    </div>
</form>
